import React from 'react';
// import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Grid, Stack, Divider, screenSizeSmaller} from 'views/components';
import {RefreshWidget} from 'views/module';

import Filter from './scene/filter/Filter';
import Header from './scene/Header';
import List from './scene/list/List';
import {generateFilterOptions} from './scene/filter/FilterGenerator';

const filterOptions = generateFilterOptions();

const defaultSelection = () => {
  return {
    order: {orderBy: 'creationTime', orderDirc: 'DESC'},
    filter: {
      status: {
        filterData: filterOptions['status'],
        optionSelected: 'ACTIVE',
      },
    },
  };
};

const JobList = (props) => {
  const [reload, setReload] = React.useState(0);
  const [selection, setSelection] = React.useState(defaultSelection());

  const smallerScreen = screenSizeSmaller('md');

  const resetFilter = () => {
    setSelection(defaultSelection());
  };

  const updateFilter = (filter, option) => {
    setSelection((e) => {
      if (option) {
        return {
          ...e,
          filter: {
            ...e.filter,
            [filter.key]: {
              filterData: filter,
              optionSelected: option.key,
            },
          },
        };
      } else {
        const newFilter = {...e.filter};
        delete newFilter[filter.key];
        return {
          ...e,
          filter: newFilter,
        };
      }
    });
  };

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Header />
      </Grid>
      <Grid item xs={12}>
        <Divider/>
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing={2} justifyContent='space-between' alignItems={{md: 'center'}}>
          <Grid item xs={12}>
            <Stack direction='row' spacing={2}>
              <Stack spacing={2} width={1} pb={{xs: 0, md: 2}} pr={{xs: 0, md: 2}}>
                <Stack spacing={2} direction={{md: 'row', xs: 'column-reverse'}}>
                  <Filter
                    selection={selection}
                    filterOptions={filterOptions}
                    updateFilter={updateFilter}
                    onClearFilter={resetFilter}
                  />
                  <RefreshWidget
                    numRefresh={reload}
                    setNumRefresh={setReload}
                    justifyContent={smallerScreen ? 'start' : 'end'}
                  />
                </Stack>
                <Stack>
                  <List
                    selection={selection}
                    reload={reload}
                    setReload={setReload}
                  />
                </Stack>
              </Stack>
            </Stack>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
JobList.propTypes = {
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(JobList));
